export default "__VITE_ASSET__QCHT0GiM__"